/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = WarningLights
 *
 * 1 = LackOfPower
 *
 * 2 = StartingProblem
 *
 * 3 = Leaks
 *
 * 4 = Noises
 *
 * 5 = Multimedia
 *
 * 6 = Display
 *
 * 7 = ElectricVehicles
 *
 * 8 = EVVehicles
 */
export enum CIFCategory {
  WarningLights = 0,
  LackOfPower = 1,
  StartingProblem = 2,
  Leaks = 3,
  Noises = 4,
  Multimedia = 5,
  Display = 6,
  ElectricVehicles = 7,
  EVVehicles = 8,
}
